export default __webpack_public_path__ + "static/media/testimonial-3.9e665952.jpeg";